// extracted by mini-css-extract-plugin
export default {"inputs":"FontSelector_inputs__tvwKD","displayer":"FontSelector_displayer__r9FzH","fade-in":"FontSelector_fade-in__aiSWv","fadeInAnimation":"FontSelector_fadeInAnimation__A-Jrv"};